/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProductListSkuMembershipOperation = {
    Add: 'add',
    Remove: 'remove'
} as const;
export type ProductListSkuMembershipOperation = typeof ProductListSkuMembershipOperation[keyof typeof ProductListSkuMembershipOperation];


// @ts-ignore
export function ProductListSkuMembershipOperationFromJSON(json: any): ProductListSkuMembershipOperation {
    return ProductListSkuMembershipOperationFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductListSkuMembershipOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductListSkuMembershipOperation {
    return json as ProductListSkuMembershipOperation;
}

// @ts-ignore
export function ProductListSkuMembershipOperationToJSON(value?: ProductListSkuMembershipOperation | null): any {
    return value as any;
}

